var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "live-coupon",
        { "not-on-tab": !_vm.ontab },
        { "no-events": _vm.liveEvents.length === 0 }
      ]
    },
    [
      ((_vm.selectedSportType === "ALL" && _vm.liveStreamedEvents.length > 0) ||
        _vm.liveStreamedEvents.filter(function(e) {
          return e.idfosporttype === _vm.selectedSportType
        }).length > 0) &&
      _vm.ontab
        ? _c(
            "div",
            { staticClass: "lsevents-checkbox-container" },
            [
              _c("v-checkbox", {
                attrs: { label: "With live streaming only" },
                model: {
                  value: _vm.showStreamingEventsOnly,
                  callback: function($$v) {
                    _vm.showStreamingEventsOnly = $$v
                  },
                  expression: "showStreamingEventsOnly"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !this.idfosporttypescsv && Object.keys(_vm.availableSportTypes).length > 0
        ? _c(
            "div",
            { staticClass: "sports" },
            [
              !_vm.ontab
                ? _c(
                    "v-tabs",
                    { attrs: { "fixed-tabs": "", "align-with-title": "" } },
                    [
                      this.isRecommendedLiveEventsEnabled &&
                      _vm.recommendedLiveEvents.length > 0
                        ? _c(
                            "v-tab",
                            {
                              staticClass: "tab_rcommended",
                              class: [
                                "tab",
                                { active: _vm.showRecommendedLiveEvents }
                              ],
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.selectRecommendedLiveEvents.apply(
                                    null,
                                    arguments
                                  )
                                }
                              }
                            },
                            [
                              _c("span", { staticClass: "sportName" }, [
                                _vm._v("Recommended")
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "numberOfEvents" }, [
                                _vm._v(_vm._s(_vm.recommendedLiveEvents.length))
                              ])
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.availableSportTypes, function(tab, index) {
                        return _c(
                          "v-tab",
                          {
                            key: index,
                            class: [
                              "tab",
                              {
                                active:
                                  _vm.selectedSportTypeComputed ===
                                  tab.idfosporttype
                              }
                            ],
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.selectSportType(tab.idfosporttype)
                              }
                            }
                          },
                          [
                            _c("span", { staticClass: "sportName" }, [
                              _vm._v(
                                _vm._s(tab.fosporttypename || tab.idfosporttype)
                              )
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "numberOfEvents" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.liveEvents.filter(function(event) {
                                    return (
                                      event.idfosporttype === tab.idfosporttype
                                    )
                                  }).length
                                )
                              )
                            ])
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _vm.liveStreamedEvents.length > 0
                        ? _c(
                            "v-tab",
                            {
                              staticClass: "tab_streaming",
                              class: [
                                "tab",
                                { active: _vm.showStreamingEventsOnly }
                              ],
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.selectEventsWithLiveStreaming.apply(
                                    null,
                                    arguments
                                  )
                                }
                              }
                            },
                            [
                              _c("span", { staticClass: "sportName" }, [
                                _vm._v("Watch Live")
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "numberOfEvents" }, [
                                _vm._v(_vm._s(_vm.liveStreamedEvents.length))
                              ]),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "igt-icon live-streaming" },
                                [
                                  _vm.mobileBigAndBelow
                                    ? _c(
                                        "v-icon",
                                        {
                                          class: _vm.showStreamingEventsOnly
                                            ? "dark"
                                            : "blue"
                                        },
                                        [_vm._v("play_arrow")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  !_vm.mobileBigAndBelow
                                    ? _c(
                                        "v-icon",
                                        {
                                          class: _vm.showStreamingEventsOnly
                                            ? "dark"
                                            : ""
                                        },
                                        [_vm._v("play_arrow")]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.avalableSportTypesMore.length > 0
                        ? _c(
                            "v-menu",
                            {
                              staticClass: "v-tabs__div",
                              attrs: {
                                "offset-y": "",
                                "max-width": "320",
                                "min-width": "212",
                                left: true,
                                bottom: true,
                                origin: "center",
                                "content-class":
                                  "menu_top_arrow_right more-tabs-menu"
                              }
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass: "more_tabs",
                                  attrs: { slot: "activator" },
                                  slot: "activator"
                                },
                                [
                                  _c("span", [_vm._v(_vm._s(_vm.$t("More")))]),
                                  _vm._v(" "),
                                  _c("v-icon", [_vm._v("expand_more")])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list",
                                _vm._l(_vm.avalableSportTypesMore, function(
                                  tab,
                                  index
                                ) {
                                  return _c(
                                    "v-list-tile",
                                    {
                                      key: index,
                                      class: [
                                        "tab",
                                        {
                                          active:
                                            _vm.selectedSportTypeComputed ===
                                            tab.idfosporttype
                                        }
                                      ],
                                      on: {
                                        click: function($event) {
                                          return _vm.selectSportType(
                                            tab.idfosporttype
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "list_title" },
                                        [
                                          _c("icon", {
                                            attrs: {
                                              colorName: "dark",
                                              name:
                                                "icon-" +
                                                (tab.idfosporttype &&
                                                  tab.idfosporttype
                                                    .split(" ")
                                                    .join("")
                                                    .toLowerCase())
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "sport_title" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  tab.fosporttypename ||
                                                    tab.idfosporttype
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "count_mob" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.liveEvents.filter(
                                                    function(event) {
                                                      return (
                                                        event.idfosporttype ===
                                                        tab.idfosporttype
                                                      )
                                                    }
                                                  ).length
                                                )
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    2
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.liveEventsPerSport.length > 0
        ? _c(
            "section",
            { staticClass: "events" },
            _vm._l(_vm.liveEventsPerSportGroupedByIDFOSport, function(fosport) {
              return _c(
                "div",
                { key: fosport.idfosport, staticClass: "live-event-container" },
                [
                  _c("big3-markets-header", {
                    attrs: {
                      coupontitle: fosport.events[0].fosportname,
                      isFlashBettingTab: _vm.isFlashBettingTab,
                      "has-draw": _vm.hasDrawPerCompetition[fosport.idfosport],
                      "is-big3-coupon":
                        _vm.isBig3CouponPerCompetition[fosport.idfosport],
                      "max-no-of-markets": _vm.maxNumberOfMarkets(
                        fosport.events
                      ),
                      "max-no-of-selections": _vm.maxNumberOfSelections(
                        fosport.events
                      ),
                      idfosporttype:
                        fosport.events &&
                        fosport.events[0] &&
                        fosport.events[0].idfosporttype,
                      isoutright: false
                    }
                  }),
                  _vm._v(" "),
                  _vm.isDebug
                    ? [
                        _vm._v(
                          "\n        fosport.fosporttypeinternalorder " +
                            _vm._s(fosport.fosporttypeinternalorder)
                        ),
                        _c("br"),
                        _vm._v(
                          "\n        fosport.fosportinternalorder " +
                            _vm._s(fosport.fosportinternalorder) +
                            "\n      "
                        )
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(fosport.events, function(event, $index) {
                    return _c(
                      "div",
                      {
                        key: $index,
                        staticClass: "event",
                        class: [
                          fosport &&
                            fosport.events &&
                            fosport.events[0] &&
                            fosport.events[0].idfosporttype,
                          { last: $index === fosport.events.length - 1 },
                          { first: $index === 0 },
                          {
                            "big-three-one-selection-per-event":
                              _vm.isBig3CouponPerCompetition[
                                fosport.idfosport
                              ] && _vm.maxNumberOfMarkets(fosport.events) === 1
                          },
                          {
                            "big3-event":
                              _vm.isBig3CouponPerCompetition[fosport.idfosport]
                          }
                        ]
                      },
                      [
                        fosport &&
                        fosport.events[0] &&
                        fosport.events[0].idfosporttype &&
                        ["GOLF", "MOTORSPORT", "NASCAR"].indexOf(
                          fosport.events[0].idfosporttype
                        ) > -1
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "outright-golf outright-event-name hheader"
                              },
                              [
                                _vm._v(
                                  "\n             " +
                                    _vm._s(
                                      event.eventname ||
                                        (event.markets &&
                                          event.markets[0] &&
                                          event.markets[0].eventname)
                                    )
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        fosport &&
                        fosport.events[0] &&
                        fosport.events[0].idfosporttype &&
                        ["GOLF", "MOTORSPORT", "NASCAR"].indexOf(
                          fosport.events[0].idfosporttype
                        ) > -1 &&
                        _vm.showOutrightMarketname
                          ? _c(
                              "div",
                              {
                                staticClass: "outright-golf outright-event-name"
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.getFilteredMarkets(event.markets)[0] &&
                                      _vm.getFilteredMarkets(event.markets)[0]
                                        .name
                                  )
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          {
                            staticClass: "wrapper",
                            class: { "flash-coupon": _vm.isFlashBettingTab }
                          },
                          [
                            _c("live-event-info", {
                              attrs: {
                                event: event,
                                page: "coupon",
                                threeselections:
                                  !_vm.isBig3CouponPerCompetition[
                                    fosport.idfosport
                                  ] &&
                                  _vm.hasDrawPerCompetition[fosport.idfosport],
                                twoselections:
                                  !_vm.isBig3CouponPerCompetition[
                                    fosport.idfosport
                                  ] &&
                                  !_vm.hasDrawPerCompetition[fosport.idfosport],
                                isbig3coupon:
                                  _vm.isBig3CouponPerCompetition[
                                    fosport.idfosport
                                  ],
                                couponname: _vm.couponname || "Live coupon"
                              }
                            }),
                            _vm._v(" "),
                            _vm.isFlashBettingEnabled && _vm.isFlashBettingTab
                              ? [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "flash-betting-container-coupon"
                                    },
                                    [
                                      _c("FlashBetting", {
                                        attrs: {
                                          flashBettingMarkets: _vm.getFlashBettingMarkets(
                                            event.markets
                                          ),
                                          mode: "coupon"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            event.markets &&
                            _vm.getFilteredMarkets(event.markets).length > 0 &&
                            !_vm.isFlashBettingTab
                              ? _c("markets", {
                                  attrs: {
                                    markets: !_vm.isBig3CouponPerCompetition[
                                      fosport.idfosport
                                    ]
                                      ? _vm.getFilteredMarkets(
                                          event.markets
                                        ) && [
                                          _vm.getFilteredMarkets(
                                            event.markets
                                          )[0]
                                        ]
                                      : _vm
                                          .getFilteredMarkets(event.markets)
                                          .filter(function(mk) {
                                            return mk.gameperiod === "1+"
                                          }),
                                    event: event,
                                    pricechangehighlight: true,
                                    islivepredefined: true,
                                    isbig3coupon:
                                      _vm.isBig3CouponPerCompetition[
                                        fosport.idfosport
                                      ],
                                    "max-no-of-markets": _vm.maxNumberOfMarkets(
                                      fosport.events
                                    ),
                                    couponname: _vm.couponname || "Live coupon"
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            event.markets &&
                            !_vm.getFilteredMarkets(event.markets).length > 0 &&
                            !_vm.isFlashBettingTab
                              ? _c("section", { staticClass: "nomarkets" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("Sports.NoAvailableMarkets"))
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.mobileBigAndBelow &&
                            _vm.brandLayout !== "generic" &&
                            _vm.brandKey !== "sb" &&
                            _vm.brandKey !== "mav" &&
                            _vm.brandKey !== "qcasino"
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "more-markets",
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.goToEvent(event)
                                      }
                                    }
                                  },
                                  [_c("v-icon", [_vm._v("add")])],
                                  1
                                )
                              : _vm._e()
                          ],
                          2
                        ),
                        _vm._v(" "),
                        !event.markets ||
                        event.markets.length === 0 ||
                        (event.markets[0].selections &&
                          event.markets[0].selections.length <= 9)
                          ? _c("live-coupon-event-footer", {
                              attrs: {
                                isStreamingAvailable: _vm.isEventStreamable(
                                  event
                                ),
                                isFlashBettingEvent:
                                  event &&
                                  Array.isArray(event.mtcgflags) &&
                                  (event.mtcgflags.includes("FlashBetting") ||
                                    event.mtcgflags.includes(
                                      "FLASHBETTINGCONTEXTUAL"
                                    )),
                                event: event,
                                couponname: _vm.couponname || "Live coupon"
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  })
                ],
                2
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      (_vm.ontab && _vm.liveEventsPerSport.length === 0) ||
      (!_vm.ontab &&
        (!_vm.liveEvents || _vm.liveEvents.length === 0) &&
        _vm.liveEventsLoaded)
        ? _c(
            "section",
            [
              _vm.brandKey !== "sb"
                ? [
                    _c("no-live-msg", {
                      attrs: { isFlashBettingTab: _vm.isFlashBettingTab }
                    })
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.brandKey === "sb"
                ? [
                    _c("div", { staticClass: "noevents" }, [
                      _c("img", {
                        attrs: {
                          src: _vm.mediaServer(
                            "/static/brand-img/sb/noLiveEvents.svg"
                          ),
                          alt: "noevents"
                        }
                      })
                    ])
                  ]
                : _vm._e()
            ],
            2
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fb0909da", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fb0909da","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/bettingoffer/live/liveCoupon.vue
// module id = null
// module chunks = 